import { Tabs, Box, Card, Grid, Text, Flex } from "@radix-ui/themes";
import React, { useEffect, useContext } from "react";
import PodcastsView from "components/PodcastsView";
import { YourGeneratedPodcastContext } from "context/LibraryYourGeneratedPodcastContext";
import { CurrentlyPlayingContext } from "context/CurrentlyPlayingContext";
import imageMapping from "imageMapping";
import coverZ from "alphabet_images/Z.png";
import api from "axios_interceptor/interceptor";
import MobileMediaPlayer from "components/MobileView/MobileMediaPlayer";
import MobileCoverCard from "components/MobileView/MobileCoverCard";
import Profile from "components/Profile";
import { UserInfoContext } from "context/UserInfoContext";

const MobileLibraryView = () => {
  const { currentYourGeneratedPodcast, setCurrentYourGeneratedPodcast } =
    useContext(YourGeneratedPodcastContext);

  const fetchMyGeneratedPodcasts = async () => {
    try {
      const response = await api.post("/utils/audio-check-by-user", {});
      const audioQueue = response.data.content;
      setCurrentYourGeneratedPodcast(audioQueue);
    } catch (error) {
      console.error("Error fetching audio status:", error);
    }
  };

  useEffect(() => {
    fetchMyGeneratedPodcasts();
  }, []);

  const { currentlyPlaying } = useContext(CurrentlyPlayingContext);
  const { currentUserInfo } = useContext(UserInfoContext);

  const filteredPodcasts = currentYourGeneratedPodcast
    .filter((podcast) => podcast.status === "COMPLETE")
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

  return (
    <>
      <div
        style={{
          paddingLeft: "10px",
          paddingRight: "10px",
          paddingTop: "10px",
        }}
      >
        <div>
          {/* Header */}
          <div
            style={{
              paddingBottom: "10px",
              position: "sticky",
              top: 0,

              zIndex: 10,
              padding: "10px 0",
            }}
          >
            <Card>
              <Flex justify="between">
                <Text>
                  {currentlyPlaying !== undefined
                    ? currentlyPlaying.title
                    : `Welcome ${currentUserInfo.display_name} 😃`}
                </Text>
                <Profile />
              </Flex>
            </Card>
          </div>

          <Card>
            <Tabs.Root defaultValue="your">
              <Tabs.List>
                <Tabs.Trigger value="your" style={{ cursor: "pointer" }}>
                  Yours
                </Tabs.Trigger>
              </Tabs.List>

              <Box pt="3">
                <Tabs.Content value="your">
                  <Text style={{ textAlign: "center", marginTop: "20px" }}>
                    🚨 Use the desktop version of Tellos to unlock its full
                    potential. 🚨
                  </Text>
                  <br/>
                  <br/>
                  {/* Check if filteredPodcasts is empty */}
                  {filteredPodcasts.length === 0 ? (
                    <Text style={{ textAlign: "center", marginTop: "20px" }}>
                      ⚠️ Head to the desktop version to start creating audio. ⚠️
                    </Text>
                  ) : (
                    <ul
                      style={{
                        listStyleType: "none",
                        padding: 0,
                        marginBottom: "100px",
                      }}
                    >
                      {filteredPodcasts.map((podcast) => {
                        const firstChar = podcast.topic.charAt(0).toUpperCase();
                        const coverImage = imageMapping[firstChar] || coverZ;
                        return (
                          <li
                            key={podcast.id}
                            style={{
                              marginBottom: "1rem",
                              padding: "1rem",
                              borderRadius: "8px",
                            }}
                          >
                            <MobileCoverCard
                              title={podcast.topic}
                              caption={podcast.created_by}
                              cover={coverImage}
                              color="hsl(0, 0%, 50%, 0.2)"
                              audioFileUrl={podcast.audio_file}
                              id={podcast.id}
                            />
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </Tabs.Content>
              </Box>
            </Tabs.Root>
          </Card>
        </div>

        {currentlyPlaying && (
          <div
            style={{
              paddingLeft: "10px",
              paddingRight: "10px",
              paddingTop: "10px",
              width: "90%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center", // Center children vertically
            }}
          >
            <MobileMediaPlayer />
          </div>
        )}
      </div>
    </>
  );
};

export default MobileLibraryView;
